export default class TaxiStartDto {
  position: string = '{"x": 0, "y":0, "z":0}';
}
